import { useQuery } from '@apollo/client';
import {
  UserDetailsDocument,
  UserDetailsQuery,
} from 'src/graphql/generated/graphql';

interface UseUserProps {
  id: string;
  skip?: boolean;
}

export const useUser = ({ id, skip }: UseUserProps) => {
  const { data, loading } = useQuery<UserDetailsQuery>(UserDetailsDocument, {
    variables: {
      id,
    },
    fetchPolicy: 'cache-and-network',
    nextFetchPolicy: 'cache-only',
    errorPolicy: 'all',
    skip,
  });

  return {
    user: data?.userDetails,
    loading,
  };
};
